"use client";

import { ShortcodeRenderer } from "@/components/ShortcodeRenderer";

interface CustomTextSectionProps {
  tenant: {
    primaryColor: string;
  };
  title?: string | null;
  description?: string | null;
  whitelabel?: boolean;
}

export function CustomTextSection({ title, description, whitelabel }: CustomTextSectionProps) {
  if (!title && !description) {
    return null;
  }

  return (
    <div className="max-w-4xl mx-auto mt-16">
      <div
        className="rounded-lg shadow-md p-8 bg-white"
        style={whitelabel ? { backgroundColor: 'var(--theme-bg, #FFFFFF)' } : undefined}
      >
        {title && (
          <h2
            className="text-2xl font-bold mb-6 text-center text-gray-900"
            style={whitelabel ? { color: 'var(--theme-text, #111827)' } : undefined}
          >
            {title}
          </h2>
        )}
        {description && (
          <ShortcodeRenderer
            content={description}
            className="prose prose-lg max-w-none [&>*]:mb-4 [&>*:last-child]:mb-0"
          />
        )}
      </div>
    </div>
  );
}
